/** *************************************/
/*             数据转换                 */
/** *************************************/

export default {
  cloneObj: cloneObj, // 深度拷贝对象
  ntime: ntime, // 获取当前时间
  dtime: dtime, // 时间戳转成时间格式
  PrefixInteger: PrefixInteger, // 个位数补0方法 （num, length） num传入的值 length数值的位数  例： （1，2）返回 01 （1，3）返回 001
  getCookie: getCookie,
  setCookie: setCookie,
  delCookie: delCookie,
}

/* 深度拷贝对象 */
function cloneObj(obj) {
  var str; var newobj = obj.constructor === Array ? [] : {}
  if (typeof obj !== 'object') {
    return
  } else if (window.JSON) {
    str = JSON.stringify(obj), // 序列化对象
      newobj = JSON.parse(str) // 还原
  } else {
    for (var i in obj) {
      newobj[i] = typeof obj[i] === 'object' ? cloneObj(obj[i]) : obj[i]
    }
  }
  return newobj
}

/** 获取当前时间
 * @param fmt {boolean} ture(yyyy - MM - dd) ; false(yyyy - MM - dd hh: mm)
 **/
function ntime(fmt = true) {
  const myDate = new Date()
  let newtime = ''
  if (fmt) {
    newtime = myDate.getFullYear() + '-' + (myDate.getMonth() + 1 < 10 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1) + '-' + '-' + (myDate.getDate() < 10 ? '0' + (myDate.getDate()) : myDate.getDate())
  } else {
    newtime = myDate.getFullYear() + '-' + (myDate.getMonth() + 1 < 10 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1) + '-' + '-' + (myDate.getDate() < 10 ? '0' + (myDate.getDate()) : myDate.getDate()) + ' ' + myDate.getHours() + ':' + myDate.getMinutes() + ':' + myDate.getSeconds()
  }
  return newtime
}

/** 时间戳转换成时间
 * @param fmt {boolean} -ture(yyyy - MM - dd) ; false(yyyy - MM - dd hh: mm)
 * @param inputTime { Number } -必选 需要转换的时间戳
 **/
function dtime(inputTime, fmt = true) {
  var datetime = new Date(inputTime)
  const Ytime = datetime.getFullYear() + '-'
  const Mtime = (datetime.getMonth() + 1 < 10 ? '0' + (datetime.getMonth() + 1) : datetime.getMonth() + 1) + '-'
  const Dtime = (datetime.getDate() < 10 ? '0' + (datetime.getDate()) : datetime.getDate())
  const htime = (datetime.getHours() < 10 ? '0' + (datetime.getHours()) : datetime.getHours()) + ':'
  const mtime = (datetime.getMinutes() < 10 ? '0' + (datetime.getMinutes()) : datetime.getMinutes()) + ':'
  const stime = (datetime.getSeconds() < 10 ? '0' + (datetime.getSeconds()) : datetime.getSeconds())
  let newtime = ''
  if (fmt) {
    newtime = newtime + Ytime + Mtime + Dtime
  } else {
    newtime = newtime + Ytime + Mtime + Dtime + ' ' + htime + mtime + stime
  }
  return newtime
}

/** 提示信息
 * @param num 传入的值
 * @param length 所需的位数
 */
function PrefixInteger(num, length) {
  return (Array(length).join('0') + num).slice(-length)
}

/**
 * 获取cookie
 */
function getCookie (name) {
  const cookieContent = '; ' + document.cookie
  const cookies = cookieContent.split(`; ${name}=`)
  return cookies.length - 1 ? cookies.pop().split(';').shift() : ''
}

/**
 * 设置cookie
 * @param {*} name 
 * @param {*} val 
 * @param {*} days 
 */
function setCookie (name, val, days) {
  let expires = ''
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    expires = `; expires=${date.toUTCString()}`
  }
  document.cookie = `${name}=${val}${expires}; path=/`
}

/**
 * 移除cookie
 * @param {*} name 
 */
function delCookie (name) {
  this.setCookie(name, '', -1)
}


// WEBPACK FOOTER //
// ./src/framework/common/qds_tools.js